import {
	linkExternal_01,
	wallet_02,
} from "@tql/ui-components-react/untitled/icons";

import { ArDashboardCard } from "../ar-dashboard-card/ar-dashboard-card.tsx";
import { IndicatorCard } from "../indicator-card/indicator-card.tsx";
import styles from "./accounts-receivable-card.module.css";

const AccountsReceivableCardContent = () => {
	return (
		<div className={styles.accountsReceivableCardWrapper}>
			<div className={styles.accountsReceivableCard}>
				<IndicatorCard
					border={true}
					icon={linkExternal_01}
					label={"Accounting Load Board"}
					onClick={() => {
						window.open(
							"https://alb.tql.com/Broker/Dashboard",
							"_blank",
							"noopener,noreferrer",
						);
					}}
					size={"small"}
					type={"info"}
				/>
			</div>
		</div>
	);
};

export const AccountsReceivableCard = () => {
	return (
		<ArDashboardCard
			content={<AccountsReceivableCardContent />}
			icon={wallet_02}
			title={"Accounts Receivable"}
		/>
	);
};
